import { _ as _objectWithoutProperties, b as _slicedToArray, d as _objectSpread2, a as _extends } from '../_rollupPluginBabelHelpers-b0164b33.js';
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Bem from '../packages/honey-bem.js';
import { Injecss } from '../packages/injecss.js';
import { L as Label } from '../index-c4501d32.js';

var styles = {
raw: ".hcr-phone-input-1-6-0{position:relative}.hcr-phone-input--error-1-6-0:before,.hcr-phone-input--valid-1-6-0:before{display:inline-block;width:24px;height:24px;content:\"\";vertical-align:middle;position:absolute;top:10px;right:12px;z-index:1}@media (min-width:1200px){.hcr-phone-input--error-1-6-0:before,.hcr-phone-input--valid-1-6-0:before{top:30px}}@media (min-width:1200px){.hcr-phone-input--no-label-1-6-0:before{top:6px}}.hcr-phone-input--error-1-6-0:before{background:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1000 1000'%3E%3Cpath d='M500 90.9A409.1 409.1 0 10909.1 500 409.1 409.1 0 00500 90.9zm-28.2 150a28.2 28.2 0 0156.4 0v373.6a28.2 28.2 0 11-56.4 0zM500 803.6a45.5 45.5 0 1145.5-45.4 45.5 45.5 0 01-45.5 45.4z' fill='rgba(255, 87, 0, 0.99)'/%3E%3C/svg%3E\") no-repeat 50%}.hcr-phone-input--valid-1-6-0:before{background:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1000 1000'%3E%3Cpath d='M500 90.9A409.1 409.1 0 10909.1 500 409.1 409.1 0 00500 90.9zm257.3 276.4L460 664.5a23.6 23.6 0 01-15.9 6.4 22.7 22.7 0 01-15.9-6.4L242.7 479.1a22.3 22.3 0 010-31.4 21.8 21.8 0 0131.8 0l169.6 169.1 283.2-281.3a22.3 22.3 0 1131.8 31.8z' fill='rgba(115, 215, 0, 0.99)'/%3E%3C/svg%3E\") no-repeat 50%}.hcr-phone-input__label-1-6-0{z-index:2}@media (min-width:1200px){.hcr-phone-input__label-1-6-0{width:100%}}.hcr-phone-input__select-addon-1-6-0{font-family:Roboto Condensed,Arial,sans-serif;font-size:16px;font-weight:300;position:relative;width:100%;height:44px;border:1px solid #c8c8c8;border-radius:5px;background-color:#fff;color:#444;line-height:1.375em;-webkit-appearance:none;-moz-appearance:none;appearance:none;background:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1000 1000'%3E%3Cpath d='M236.4 365.9a28.2 28.2 0 0140.4 0l216.4 216.4a8.2 8.2 0 0013.6 0l216.4-216.4a28.6 28.6 0 0140.4 40.5L545.5 622.7a66.4 66.4 0 01-45.5 19.6 66.4 66.4 0 01-45.5-19.6L236.4 406.4a28.2 28.2 0 010-40.5z' fill='rgba(139, 139, 139, 0.99)'/%3E%3C/svg%3E\") no-repeat 50%;display:none;position:absolute;width:116px;padding:0 36px 0 12px;border-top:0;border-bottom:0;border-left:0;border-radius:0;background-position:center right 12px;background-size:24px;line-height:44px;text-align:left;text-overflow:ellipsis;white-space:nowrap;overflow:hidden;z-index:1;pointer-events:none}@media (min-width:1200px){.hcr-phone-input__select-addon-1-6-0{height:36px}}.hcr-phone-input__select-addon-1-6-0::-webkit-input-placeholder{color:#757575;font-style:italic}.hcr-phone-input__select-addon-1-6-0::-moz-placeholder{color:#757575;font-style:italic}.hcr-phone-input__select-addon-1-6-0:-ms-input-placeholder{color:#757575;font-style:italic}.hcr-phone-input__select-addon-1-6-0::-ms-input-placeholder{color:#757575;font-style:italic}.hcr-phone-input__select-addon-1-6-0::placeholder{color:#757575;font-style:italic}@media (min-width:1200px){.hcr-phone-input__select-addon-1-6-0{width:144px;line-height:36px}}.hcr-phone-input__select-1-6-0{font-family:Roboto Condensed,Arial,sans-serif;font-size:16px;font-weight:300;position:relative;width:100%;height:44px;border:1px solid #c8c8c8;border-radius:5px;background-color:#fff;color:#444;line-height:1.375em;text-overflow:ellipsis;-webkit-appearance:none;-moz-appearance:none;appearance:none;background:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1000 1000'%3E%3Cpath d='M236.4 365.9a28.2 28.2 0 0140.4 0l216.4 216.4a8.2 8.2 0 0013.6 0l216.4-216.4a28.6 28.6 0 0140.4 40.5L545.5 622.7a66.4 66.4 0 01-45.5 19.6 66.4 66.4 0 01-45.5-19.6L236.4 406.4a28.2 28.2 0 010-40.5z' fill='rgba(139, 139, 139, 0.99)'/%3E%3C/svg%3E\") no-repeat 50%;position:absolute;width:116px;padding:0 36px 0 12px;border-top:0;border-bottom:0;border-left:0;border-radius:0;background-position:center right 12px;background-size:24px;z-index:1}@media (min-width:1200px){.hcr-phone-input__select-1-6-0{height:36px}}.hcr-phone-input__select-1-6-0::-webkit-input-placeholder{color:#757575;font-style:italic}.hcr-phone-input__select-1-6-0::-moz-placeholder{color:#757575;font-style:italic}.hcr-phone-input__select-1-6-0:-ms-input-placeholder{color:#757575;font-style:italic}.hcr-phone-input__select-1-6-0::-ms-input-placeholder{color:#757575;font-style:italic}.hcr-phone-input__select-1-6-0::placeholder{color:#757575;font-style:italic}@media (min-width:1200px){.hcr-phone-input__select-1-6-0{width:144px}}.hcr-phone-input__field-1-6-0{font-family:Roboto Condensed,Arial,sans-serif;font-size:16px;font-weight:300;position:relative;width:100%;height:44px;border:1px solid #c8c8c8;border-radius:5px;background-color:#fff;color:#444;line-height:1.375em;text-overflow:ellipsis;-webkit-appearance:none;-moz-appearance:none;appearance:none;padding:0 12px 0 128px}@media (min-width:1200px){.hcr-phone-input__field-1-6-0{height:36px}}.hcr-phone-input__field-1-6-0::-webkit-input-placeholder{color:#757575;font-style:italic}.hcr-phone-input__field-1-6-0::-moz-placeholder{color:#757575;font-style:italic}.hcr-phone-input__field-1-6-0:-ms-input-placeholder{color:#757575;font-style:italic}.hcr-phone-input__field-1-6-0::-ms-input-placeholder{color:#757575;font-style:italic}.hcr-phone-input__field-1-6-0::placeholder{color:#757575;font-style:italic}@media (min-width:1200px){.hcr-phone-input__field-1-6-0{padding-left:156px}}.hcr-phone-input__field-1-6-0:focus{border-color:#757575;outline:0}.hcr-phone-input__info-1-6-0{color:#444;font-size:14px;font-weight:300;line-height:17px;display:block;width:100%}.hcr-phone-input--error-1-6-0 .hcr-phone-input__info-1-6-0{color:#c64300}.hcr-phone-input--active-1-6-0{outline:0}.hcr-phone-input--active-1-6-0 .hcr-phone-input__field-1-6-0{border-color:#757575}.hcr-phone-input--error-1-6-0 .hcr-phone-input__field-1-6-0,.hcr-phone-input--error-1-6-0 .hcr-phone-input__select-1-6-0{border-color:#ff5700}.hcr-phone-input--error-1-6-0 .hcr-phone-input__select-1-6-0{border-right-color:#c8c8c8}.hcr-phone-input--disabled-1-6-0 .hcr-phone-input__field-1-6-0,.hcr-phone-input--disabled-1-6-0 .hcr-phone-input__select-1-6-0,.hcr-phone-input--disabled-1-6-0 .hcr-phone-input__select-addon-1-6-0{cursor:not-allowed;opacity:.5}.hcr-phone-input--has-select-addon-1-6-0 .hcr-phone-input__select-1-6-0{opacity:0}.hcr-phone-input--has-select-addon-1-6-0 .hcr-phone-input__select-addon-1-6-0{display:inline-block}.hcr-phone-input--has-select-addon-sm-1-6-0 .hcr-phone-input__select-1-6-0{width:72px;opacity:0}.hcr-phone-input--has-select-addon-sm-1-6-0 .hcr-phone-input__select-addon-1-6-0{display:inline-block;width:72px}.hcr-phone-input--has-select-addon-sm-1-6-0 .hcr-phone-input__field-1-6-0{padding-left:84px}",
map:{"hcr-phone-input":"hcr-phone-input-1-6-0","hcr-phone-input--error":"hcr-phone-input--error-1-6-0","hcr-phone-input--valid":"hcr-phone-input--valid-1-6-0","hcr-phone-input--no-label":"hcr-phone-input--no-label-1-6-0","hcr-phone-input__label":"hcr-phone-input__label-1-6-0","hcr-phone-input__select-addon":"hcr-phone-input__select-addon-1-6-0","hcr-phone-input__select":"hcr-phone-input__select-1-6-0","hcr-phone-input__field":"hcr-phone-input__field-1-6-0","hcr-phone-input__info":"hcr-phone-input__info-1-6-0","hcr-phone-input--active":"hcr-phone-input--active-1-6-0","hcr-phone-input--disabled":"hcr-phone-input--disabled-1-6-0","hcr-phone-input--has-select-addon":"hcr-phone-input--has-select-addon-1-6-0","hcr-phone-input--has-select-addon-sm":"hcr-phone-input--has-select-addon-sm-1-6-0"}};

var bem = Bem('phone-input', styles);
var PhoneInput = function PhoneInput(_ref) {
  var active = _ref.active,
      disabled = _ref.disabled,
      extraClasses = _ref.extraClasses,
      extraClassesAddOn = _ref.extraClassesAddOn,
      label = _ref.label,
      info = _ref.info,
      id = _ref.id,
      requiredText = _ref.requiredText,
      valid = _ref.valid,
      callingCodes = _ref.callingCodes,
      value = _ref.value,
      nativeSelect = _ref.nativeSelect,
      selectAddOn = _ref.selectAddOn,
      selectAddOnSm = _ref.selectAddOnSm,
      selectRest = _ref.selectRest,
      rest = _objectWithoutProperties(_ref, ["active", "disabled", "extraClasses", "extraClassesAddOn", "label", "info", "id", "requiredText", "valid", "callingCodes", "value", "nativeSelect", "selectAddOn", "selectAddOnSm", "selectRest"]);

  /**
   * Makes sure phone number starts with "+", replaces 00 prefix if found
   */
  var normalizePhoneNumber = function normalizePhoneNumber(phoneNumber) {
    return phoneNumber.replace(/^(\+|00)/, '+');
  };
  /**
   * Matches given phone number to the list of provided calling codes,
   * extracts the code if the match is found
   * @param phoneNumber {string}
   * @returns {string}
   */


  var getCallingCodeFromNumber = function getCallingCodeFromNumber(phoneNumber) {
    var callingCode = '';
    var phoneNumberNormalized = normalizePhoneNumber(phoneNumber);
    callingCodes.forEach(function (option) {
      // check if phone number starts with one of the provided codes
      if (phoneNumberNormalized.indexOf(option.value) === 0) {
        callingCode = option.value;
      }
    });
    return callingCode;
  };
  /**
   * returns country name from the provided options
   * that corresponds to the code provided
   * @param callingCode {string}
   * @returns {string}
   */


  var getCountryByCallingCode = function getCountryByCallingCode(callingCode) {
    var countryName = '';
    callingCodes.forEach(function (option) {
      // check if phone number starts with one of the provided codes
      if (option.value === callingCode) {
        countryName = option.country;
      }
    });
    return countryName;
  };
  /**
   * returns country code from the provided options
   * that corresponds to the calling code provided
   * @param callingCode {string}
   * @returns {string}
   */


  var getCountryCodeByCallingCode = function getCountryCodeByCallingCode(callingCode) {
    var returnCode = '';
    callingCodes.forEach(function (option) {
      // check if phone number starts with one of the provided codes
      if (option.value === callingCode) {
        returnCode = option.countryCode;
      }
    });
    return returnCode;
  }; // if no value provided, use first item in the options code list


  var initialCode = value ? getCallingCodeFromNumber(value) : callingCodes[0].value;
  var initialNumber = value || initialCode; // initialize state variables using useState hook and populate default values
  // @todo decide if one state object makes more sense

  var _useState = useState(initialCode),
      _useState2 = _slicedToArray(_useState, 2),
      code = _useState2[0],
      setCode = _useState2[1];

  var _useState3 = useState(initialNumber),
      _useState4 = _slicedToArray(_useState3, 2),
      number = _useState4[0],
      setNumber = _useState4[1];

  var _useState5 = useState(getCountryByCallingCode(initialCode)),
      _useState6 = _slicedToArray(_useState5, 2),
      country = _useState6[0],
      setCountry = _useState6[1];

  var _useState7 = useState(getCountryCodeByCallingCode(initialCode)),
      _useState8 = _slicedToArray(_useState7, 2),
      countryCode = _useState8[0],
      setCountryCode = _useState8[1];
  /**
   * Handles country code selection change, replaces phone with the country code if not possible
   * @param e {object} event object from code select
   */


  var handleCountryChange = function handleCountryChange(e) {
    setCode(e.target.value);
    setCountry(getCountryByCallingCode(e.target.value));
    setCountryCode(getCountryCodeByCallingCode(e.target.value)); // if phone has a code from the list of options, replace it,
    // if not replace phone with the code

    if (code) {
      // replace the code if possible, normalize the number first (make sure it starts with "+")
      var phoneNumberNormalized = normalizePhoneNumber(number);
      setNumber(phoneNumberNormalized.replace(code, e.target.value));
    } else {
      setNumber(e.target.value);
    }
  };
  /**
   * Updates calling code and country if the number was changed in the input field
   * @param e {object} event object from phone number input
   */


  var handlePhoneChange = function handlePhoneChange(e) {
    setNumber(e.target.value);
    var codeFromNumber = getCallingCodeFromNumber(e.target.value);
    setCode(codeFromNumber);
    setCountry(getCountryByCallingCode(codeFromNumber));
    setCountryCode(getCountryCodeByCallingCode(codeFromNumber));
  };
  /**
   * Render logic starts here
   */
  // populating the calling codes options from the array given in props


  var countryOpts = [];

  for (var i = 0; i < callingCodes.length; i += 1) {
    // deconstruct the object to assign all optional props as ...restProps
    var _callingCodes$i = _objectSpread2({}, callingCodes[i]),
        optValue = _callingCodes$i.value,
        displayValue = _callingCodes$i.country,
        optionKey = _callingCodes$i.countryCode,
        key = _callingCodes$i.key; // crating option elements,
    // using country codes as the calling codes seem to not be unique per country


    countryOpts.push(React.createElement("option", {
      key: key || optionKey,
      value: optValue
    }, displayValue || optValue));
  } // creating BEM class names and modifiers


  var inputClassNames = bem.b({
    valid: valid === true,
    error: valid === false,
    disabled: disabled,
    active: active,
    'has-select-addon': !nativeSelect,
    'has-select-addon-sm': selectAddOnSm // @todo this needs a better name =(

  }, extraClasses);
  return React.createElement("div", {
    className: inputClassNames
  }, label && React.createElement(Label, {
    extraClasses: bem.e('label'),
    text: label,
    labelFor: id,
    requiredText: requiredText
  }), // if native select is not enforced display custom container with the current value
  !nativeSelect && React.createElement("div", {
    className: bem.e('select-addon', false, extraClassesAddOn)
  }, // if custom render function passed use it's result within the addon
  selectAddOn && selectAddOn(code, countryCode, country), // default content for addon is displaying the select text/country
  // comparing to the native select this allows us apply styling such as text overflow
  !selectAddOn && country), React.createElement("select", _extends({
    className: bem.e('select'),
    onChange: handleCountryChange,
    disabled: disabled,
    value: code
  }, selectRest), countryOpts), React.createElement("input", _extends({
    type: "tel",
    id: id,
    disabled: disabled,
    required: requiredText ? true : _objectSpread2({}, rest).required,
    className: bem.e('field'),
    onChange: handlePhoneChange,
    value: number
  }, rest)), info && React.createElement("span", {
    className: bem.e('info')
  }, info));
};
PhoneInput.displayName = 'PhoneInput';
PhoneInput.defaultProps = {
  active: null,
  disabled: null,
  extraClasses: '',
  extraClassesAddOn: '',
  info: null,
  requiredText: null,
  valid: null,
  value: '',
  nativeSelect: false,
  selectRest: {}
};
PhoneInput.propTypes = {
  /** Country/codes options for the select box,
   * every element should contain value, country and countryCode properties */
  callingCodes: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    countryCode: PropTypes.string.isRequired,
    country: PropTypes.string.isRequired // @todo figure out if we need a countryName as well

  })).isRequired,

  /** Phone input's default value, you can pre-fill the calling code or even a number if you want */
  value: PropTypes.string,

  /** Triggers element visual active state */
  active: PropTypes.bool,

  /** Triggers visual validation output */
  valid: PropTypes.bool,

  /** Disables the input if set */
  disabled: PropTypes.bool,

  /** Provides label text, required if aria-label is not passed */

  /* eslint-disable react/require-default-props */
  // we want label to be always checked against
  label: function label(_ref2) {
    var ariaLabel = _ref2['aria-label'],
        _label = _ref2.label;
    // if no aria label nor label throw validation error
    return !ariaLabel && !_label ? new Error('Either label or aria label are required') : null;
  },

  /** Custom classes name for input element */
  extraClasses: PropTypes.string,

  /** Custom classes name for select add on if provided */
  extraClassesAddOn: PropTypes.string,

  /** Provides extra information for this input field */
  info: PropTypes.string,

  /** Defines element ID that is used to bind it to the label */
  id: PropTypes.string.isRequired,

  /** Marks the element as required, adds specified text to label text,
   * e.g. Phone (Mandatory) for required="(Mandatory)" */
  requiredText: PropTypes.string,

  /** Forces native select to be displayed as callingCode selector */
  nativeSelect: PropTypes.bool,

  /** allows customizing what gets displayed as selected value, only works if `nativeSelect: false`
   * accepts code, countryCode, country params */
  selectAddOn: PropTypes.func,

  /** Makes addon container smaller in size, perfect for flags */
  selectAddOnSm: PropTypes.bool,

  /** Rest props passed to calling code select, for maximum customization flexibility */
  selectRest: PropTypes.object
};
var phoneInput = Injecss(PhoneInput, styles);

export { phoneInput as PhoneInput };
